import { render, staticRenderFns } from "./FyberIcon.vue?vue&type=template&id=a33a9c8e&"
import script from "./FyberIcon.vue?vue&type=script&lang=js&"
export * from "./FyberIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports